// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5fa09749","404":"f77f27f9","498":"9d9aaf06"}[chunkId] + ".chunk.js";
};